/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useState } from 'react'
import {
    CheckIcon,
} from '@heroicons/react/24/outline'
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";
import TextInput from "../../components/TextInput";
import SelectInput from "../../components/SelectInput";
import RadioButtons from "../../components/RadioButtons";
import FileInput from "../../components/FileInput";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import PatientModuleHeader from "../../components/patients/layout/PatientModuleHeader";
import PatientModuleLayout from "../../components/patients/layout/PatientModuleLayout";


const radio = [
    { id: "male", default: true, label: "Masculino", value: "1" },
    { id: "female", default: false, label: "Femenino", value: "2" }
]

const roles = [
    { id: 'lic', default: true, label: 'Lic.', value: "5" },
    { id: "resident", default: false, label: "Dr. Residente", value: "1" },
    { id: "senior", default: false, label: "Dr. Senior", value: "3" },
    { id: "secretary", default: false, label: "Secretaría", value: "2" },
    { id: "admin", default: false, label: "Administrador", value: "4" },
    // { id: "bachelor", default: false, label: "Administrador", value: 5 },
]

export default function UserNewPage() {

    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [sidebarOpenDesktop, setSidebarOpenDesktop] = useState(true)
    const isDesktop = useMediaQuery("(min-width: 1024px)")
    // eslint-disable-next-line no-unused-vars
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate();
    const { idUser } = useParams()
    const [specialties, setSpecialties] = useState([]);
    const [user, setUser] = useState({
        sex: '1',
        role: '5',
    });
    const [error, setError] = useState({});

    const handleChange = (field, value) => setUser((prev) => ({ ...prev, [field]: value }));
    const handleNumber = (field, value) => setUser((prev) => ({ ...prev, [field]: value.replace(/\D/g, '') }));
    const handleSidebarToggle = () => {
        if (isDesktop) {
            setSidebarOpenDesktop(!sidebarOpenDesktop);
            return;
        }
        setSidebarOpen(true);
    };

    useEffect(() => {
        if (isDesktop) {
            setSidebarOpen(false);
        }
    }, [isDesktop])

    const handleSubmit = (event) => {
        event.preventDefault()
        if (user.role === '4' || user.role === '2') {
            delete user.digitalSignature
            delete user.specialty
            delete user.registrationNumber
        } else if (user.registrationNumber) {
            handleChange('registrationNumber', parseInt(user.registrationNumber))
        }
        if (user.role === '1' || user.role === '3' || user.role === '5' || user.role === 1 || user.role === 3 || user.role === 5) {
            let formData = new FormData();
            for (var key in user) {
                if (user[key] && (key !== 'digitalSignature' || typeof user[key] === 'object')) {
                    formData.append(key, user[key]);
                }
            }
            if (idUser) {
                api.users.update(idUser, formData).then((response) => navigate('/users')).catch((error) => { setError(error.message); setLoading(false); })
            } else {
                api.users.create(formData).then(() => navigate('/users')).catch(response => {
                    setError(response.message)
                }
                )
            }
        } else {
            if (idUser) {
                api.users.update(idUser, user).then((response) => navigate('/users')).catch((error) => { setError(error.message); setLoading(false); })
            } else {
                api.users.create(user).then((response) => navigate('/users')).catch(error => {
                    setError(error.message)
                }
                )
            }
        }
    };

    useEffect(() => {
        api.specialties.getMulti().then((response) => {
            setSpecialties(response)
        })
        if (idUser) {
            api.users.getOne(idUser).then((response) => {
                console.log(response)
                setUser({ ...response, sex: response.sex.toString(), role: response.role.toString() })
            })
        }
    }, [])

    useEffect(() => {
        if (user.role === '4' || user.role === '2') {
            delete user.digitalSignature
            delete user.specialty
            delete user.registrationNumber
        }
        if (user.role === '1' || user.role === '3' || user.role === '5') {
            handleChange('specialty', '1')
        }
    }, [user.role])

    const pages = [
        { name: 'Usuarios', href: '/users', current: false },
        { name: idUser ? 'Detalle' : 'Nuevo usuario', href: `#`, current: true },
    ]

    return (
        <PatientModuleLayout
            currentScreen="Usuarios"
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
            sidebarOpenDesktop={sidebarOpenDesktop}
            header={
                <PatientModuleHeader
                    pages={pages}
                    onToggleSidebar={handleSidebarToggle}
                    mobileBackTo="/users"
                    mobileBackLabel="Usuarios"
                    mobileTitle={idUser ? 'Detalle de usuario' : 'Nuevo usuario'}
                    actions={
                        <button
                            type="submit"
                            form="user-form"
                            className="inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-3 py-2.5 text-sm font-semibold text-white shadow-sm"
                        >
                            <CheckIcon className="h-5 w-5" />
                            <span className="hidden sm:inline">Guardar usuario</span>
                            <span className="sm:hidden">Guardar</span>
                        </button>
                    }
                />
            }
        >
            <div className="px-4 py-6 sm:px-6 lg:px-8">
                <div className="mb-6 lg:hidden">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
                        {idUser ? 'Detalle de usuario' : 'Nuevo usuario'}
                    </h1>
                </div>

                <form id="user-form" onSubmit={(event) => handleSubmit(event)}>
                    <div className="mx-auto w-full max-w-5xl">
                        <div className="grid grid-cols-1 gap-6 rounded-lg bg-white p-4 shadow-sm dark:bg-gray-900 sm:grid-cols-2 sm:p-6 lg:p-8">
                            <TextInput showErrorMessage={true} required={true} containerClassName='w-full' errorMessage={error?.firstName} value={user?.firstName} handleChange={handleChange} name="firstName" label="Nombres" />
                            <TextInput showErrorMessage={true} required={true} containerClassName='w-full' errorMessage={error?.lastName} value={user?.lastName} handleChange={handleChange} name="lastName" label="Apellidos" />
                            <TextInput showErrorMessage={true} required={true} containerClassName='w-full' errorMessage={error?.email} value={user?.email} handleChange={handleChange} name="email" label="Correo Electrónico" />
                            <TextInput showErrorMessage={true} required={true} containerClassName='w-full' errorMessage={error?.govId} value={user?.govId} handleChange={handleChange} name="govId" label="Cédula de identidad" />
                            <TextInput showErrorMessage={true} required={true} containerClassName='w-full' errorMessage={error.cellphone} handleChange={handleNumber} value={user.cellphone} name="cellphone" label="Celular" />
                            <RadioButtons defaultValue={user?.sex} value={user?.sex} handleChange={handleChange} name="sex" label="Sexo" options={radio} />
                            <div className="sm:col-span-2">
                                <RadioButtons optionsContainerStyle='space-y-4 sm:flex sm:items-center sm:space-y-0 sm:gap-x-20' defaultValue={user?.role} value={user?.role} handleChange={handleChange} name='role' label='Rol' options={roles} />
                            </div>
                            {(user?.role === '1' || user?.role === '3' || user?.role === '5') &&
                                <div className="mx-auto w-full gap-4 flex flex-col sm:col-span-2 sm:w-1/2">
                                    <TextInput showErrorMessage={true} errorMessage={error.registrationNumber} handleChange={handleNumber} value={user?.registrationNumber} name="registrationNumber" label="Reg. Prof. Nro" />
                                    <SelectInput errorMessage={error?.specialty} value={user?.specialty} handleChange={handleChange} name="specialty" label="Especialidad" className="shadow-sm pl-2 w-full bg-white border border-gray-300 focus:ring-primary focus:border-primary block sm:text-sm rounded-md input-base" options={specialties.map((element) => (<option value={element.id} label={element.name}>{element.name}</option>))} />
                                    <FileInput label='Agregar Firma' buttonText='Adjuntar Firma' handleChange={handleChange} name='digitalSignature' value={user?.digitalSignature} />
                                </div>
                            }
                        </div>
                    </div>
                </form>
            </div>
        </PatientModuleLayout>
    );
}
